import Modal from "../../../../shared/components/ui/Modal";
import "../../styles/PrivacyNoticeModal.css";

const sections = [
    {
        title: "1. Responsable del tratamiento de los datos personales.",
        paragraphs: [
            "[Nombre del Sujeto Obligado], con domicilio en [domicilio oficial], es el responsable del tratamiento de los datos personales recabados a través de la Plataforma de Certificados Únicos Ciudadanos, Patrimoniales y Empresariales",
            "El tratamiento de los datos personales se realiza con fundamento en los artículos 6, apartado A, fracción II, y 16, segundo párrafo, de la Constitución Política de los Estados Unidos Mexicanos; los artículos 1, 2, 3, 16, 17, 18, 22, 25 y demás aplicables de la Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados; los artículos 1, 2, 3, 4, 5, 7, 10, 12 15, 37, 42, 52, 59, 63 y demás relativos y aplicables de la Ley de Protección de Datos Personales en Posesión de Sujetos Obligados del Estado de Querétaro; el artículo 26, de la Ley de Transparencia y Acceso a la Información Pública del Estado de Querétaro, en lo que resulte aplicable; así como en las disposiciones jurídicas que confieren atribuciones a [Nombre del Sujeto Obligado] para la integración de expedientes, la validación de identidad, la consulta de registros administrativos y la expedición de Certificados Únicos Ciudadanos, Patrimoniales y Empresariales.",
            "El responsable tratará los datos personales observando los principios de licitud, finalidad, lealtad, consentimiento, calidad, proporcionalidad, información y responsabilidad, así como los deberes de seguridad y confidencialidad previstos en la legislación aplicable.",
        ],
    },
    {
        title: "2. Datos personales que serán sometidos a tratamiento.",
        paragraphs: [
            "Para el cumplimiento de las finalidades descritas en el presente aviso, podrán recabarse, según corresponda, los siguientes datos personales:",
        ],
        bullets: [
            "Nombre completo.",
            "Clave Única de Registro de Población (CURP).",
            "Registro Federal de Contribuyentes (RFC).",
            "Fecha y lugar de nacimiento.",
            "Domicilio.",
            "Correo electrónico.",
            "Número telefónico.",
            "Firma autógrafa o firma electrónica.",
            "Identificación oficial.",
            "Datos laborales o de representación legal.",
            "Datos de personas morales, incluyendo razón social, denominación, acta constitutiva, poderes, representantes legales y demás información necesaria para la emisión de certificados empresariales (comprobantes de ingresos, opiniones administrativas o fiscales,estados financieros, )",
            "Información patrimonial cuando resulte indispensable para la emisión del certificado correspondiente.",
            "Información contenida en registros administrativos o bases de datos gubernamentales que legalmente puedan ser consultadas.",
        ],
        paragraphsAfter: [
            "Cuando resulte estrictamente necesario y exista fundamento legal, podrán tratarse datos personales sensibles conforme a las disposiciones legales aplicables, implementando las medidas de seguridad reforzadas correspondientes.",
        ],
    },
    {
        title: "3. Finalidades del tratamiento",
        paragraphs: ["Los datos personales serán tratados para las siguientes finalidades primarias:"],
        bullets: [
            "Identificar y autenticar a las personas usuarias de la plataforma.",
            "Integrar y administrar expedientes electrónicos.",
            "Validar la identidad de personas físicas y morales.",
            "Emitir certificados únicos ciudadanos, patrimoniales y empresariales.",
            "Verificar la autenticidad y vigencia de la información proporcionada.",
            "Consultar información en registros gubernamentales cuando exista atribución legal.",
            "Dar seguimiento a solicitudes, trámites y servicios.",
            "Generar folios, constancias y mecanismos de verificación electrónica.",
            "Atender requerimientos de autoridades competentes.",
            "Cumplir obligaciones legales y administrativas.",
            "Mantener bitácoras de seguridad, auditoría y trazabilidad de las operaciones realizadas en la plataforma.",
            "Obtener información para unificar diversos trámites en un solo certificado.",
        ],
        paragraphsAfter: [
            "Como finalidades secundarias, cuando proceda conforme a la normatividad aplicable, los datos podrán utilizarse para:",
        ],
        bulletsAfter: [
            "Elaboración de estadísticas institucionales.",
            "Evaluación y mejora de los servicios públicos.",
            "Desarrollo de indicadores institucionales.",
        ],
        paragraphsEnd: [
            "Las estadísticas e informes se elaborarán procurando que la información no permita identificar a los titulares.",
        ],
    },
    {
        title: "4. Fundamento legal",
        paragraphs: ["El tratamiento de los datos personales se realiza con fundamento en:"],
        bullets: [
            "La Constitución Política de los Estados Unidos Mexicanos.",
            "Constitución Política del Estado Libre y Soberano de Querétaro.",
            "La Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados.",
            "La Ley de Protección de Datos Personales en Posesión de Sujetos Obligados del Estado de Querétaro.",
            "Ley de Firma Electrónica Avanzada para el Estado de Querétaro.",
            "Ley de Gobierno Digital del Estado de Querétaro.",
        ],
    },
    {
        title: "5. Transferencias de datos personales",
        paragraphs: [
            "Los datos personales podrán ser transferidos, sin requerir el consentimiento del titular, cuando se actualice alguno de los supuestos previstos en la Ley General y en la Ley de Protección de Datos Personales en Posesión de Sujetos Obligados del Estado de Querétaro, entre otros:",
        ],
        bullets: [
            "A las autoridades competentes en ejercicio de sus atribuciones.",
            "A órganos fiscalizadores.",
            "A las autoridades jurisdiccionales.",
            "A organismos garantes de transparencia y protección de datos personales.",
            "A otros sujetos obligados cuando la transferencia sea necesaria para el ejercicio de facultades propias, compatibles o análogas.",
        ],
        paragraphsAfter: ["Fuera de estos supuestos, cualquier transferencia se realizará conforme a las disposiciones legales aplicables."],
    },
    {
        title: "6. Mecanismos para ejercer los derechos ARCO.",
        paragraphs: [
            "La persona titular de los datos personales podrá ejercer sus derechos de Acceso, Rectificación, Cancelación y Oposición (ARCO), así como los derechos relacionados con la protección de sus datos personales, mediante solicitud presentada ante la Unidad de Transparencia de [Nombre del Sujeto Obligado].",
            "La solicitud deberá contener los requisitos establecidos en la legislación aplicable y podrá presentarse:",
        ],
        bullets: [
            "Presencialmente en la Unidad de Transparencia.",
            "A través de la Plataforma Nacional de Transparencia.",
            "Por los medios electrónicos o físicos autorizados por el sujeto obligado.",
        ],
        paragraphsAfter: ["La Unidad de Transparencia atenderá las solicitudes dentro de los plazos previstos por la ley."],
    },
    {
        title: "7. Domicilio de la Unidad de Transparencia.",
        paragraphs: [
            "Unidad de Transparencia de [Nombre del Sujeto Obligado]",
            "Domicilio: [domicilio]",
            "Teléfono: [número]",
            "Correo electrónico: [correo institucional]",
            "Horario de atención: [horario]",
        ],
    },
    {
        title: "8. Medidas de seguridad",
        paragraphs: [
            "El responsable implementa medidas de seguridad administrativas, físicas y técnicas para proteger los datos personales contra daño, pérdida, alteración, destrucción, uso, acceso o tratamiento no autorizado, conforme al análisis de riesgos y a la normatividad aplicable.",
            "Asimismo, la plataforma cuenta con mecanismos de autenticación, control de accesos, registros de auditoría, respaldo de información y demás controles necesarios para preservar la confidencialidad, integridad y disponibilidad de los datos personales.",
        ],
    },
    {
        title: "9. Uso de tecnologías de monitoreo",
        paragraphs: [
            "La plataforma podrá utilizar cookies, registros de sesión y otras tecnologías para garantizar el funcionamiento del sistema, fortalecer la seguridad informática, autenticar usuarios y obtener información estadística sobre el uso de la plataforma.",
            "Estas tecnologías no tendrán finalidades distintas a las autorizadas por la legislación aplicable.",
        ],
    },
    {
        title: "10. Cambios al aviso de privacidad",
        paragraphs: [
            "El presente aviso de privacidad podrá ser modificado cuando exista un cambio en la normatividad, en las atribuciones del sujeto obligado, en los servicios ofrecidos o en cualquier otra circunstancia que lo justifique.",
            "Las modificaciones serán publicadas en el portal oficial del sujeto obligado y en la Plataforma de Certificados Únicos Ciudadanos, Patrimoniales y Empresariales.",
        ],
    },
    {
        title: "11. Medio para consultar el aviso de privacidad",
        paragraphs: [
            "El aviso de privacidad integral estará disponible permanentemente en el portal institucional y dentro de la Plataforma de Certificados Únicos Ciudadanos, Patrimoniales y Empresariales.",
            "Fecha de última actualización: [día] de [mes] de [año].",
        ],
    },
];

function NoticeContent() {
    return (
        <div className="privacy-notice-content">
            <p className="privacy-notice-subtitle">
                Plataforma de Certificados Únicos Ciudadanos, Patrimoniales y Empresariales.
            </p>
            {sections.map(({ title, paragraphs, bullets, paragraphsAfter, bulletsAfter, paragraphsEnd }) => (
                <section className="privacy-notice-section" key={title}>
                    <h3>{title}</h3>
                    {paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                    {bullets && <ul>{bullets.map((item) => <li key={item}>{item}</li>)}</ul>}
                    {paragraphsAfter?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                    {bulletsAfter && <ul>{bulletsAfter.map((item) => <li key={item}>{item}</li>)}</ul>}
                    {paragraphsEnd?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                </section>
            ))}
        </div>
    );
}

function PrivacyNoticeModal({ isOpen, onClose }) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Aviso de privacidad integral"
            size="xl"
            footer={(
                <button className="privacy-notice-close" type="button" onClick={onClose}>
                    Cerrar aviso
                </button>
            )}
        >
            <NoticeContent />
        </Modal>
    );
}

export default PrivacyNoticeModal;